<!--
    A small prev / next pager for a list the page cuts into pages itself: "‹ הקודם  11-20 מתוך 86  הבא ›".
    v-model = the page index (0-based). Renders nothing while the whole list fits on one page.
    The parent slices its rows (list.slice(page * pageSize, (page + 1) * pageSize)) and keeps the page in range.
-->
<template>
    <div v-if="total > pageSize"
         class="listPager">
        <button type="button"
                class="listPagerButton listPagerPrev"
                :disabled="current <= 0"
                @click="go(current - 1)">
            <i class="fa-solid fa-chevron-right"></i>
            הקודם
        </button>
        <span class="listPagerRange">{{ first }}-{{ last }} מתוך {{ total }}</span>
        <button type="button"
                class="listPagerButton listPagerNext"
                :disabled="current >= pageCount - 1"
                @click="go(current + 1)">
            הבא
            <i class="fa-solid fa-chevron-left"></i>
        </button>
    </div>
</template>

<script>
export default {
    name: 'ListPager',

    props: {
        value: { type: Number, default: 0 },
        total: { type: Number, default: 0 },
        pageSize: { type: Number, default: 10 }
    },

    computed: {
        pageCount() {
            return Math.max(1, Math.ceil(this.total / this.pageSize));
        },
        current() {
            return Math.min(Math.max(0, this.value), this.pageCount - 1);
        },
        first() {
            return this.current * this.pageSize + 1;
        },
        last() {
            return Math.min(this.total, (this.current + 1) * this.pageSize);
        }
    },

    methods: {
        go(page) {
            if (page >= 0 && page < this.pageCount)
                this.$emit('input', page);
        }
    }
}
</script>

<style>
.listPager {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    margin-top: 6px;
    font-size: 13px;
    color: #777;
}

.listPagerButton {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 3px 8px;
    border: 0;
    border-radius: 4px;
    background: transparent;
    color: #ab8ce4;
    font-size: 13px;
    cursor: pointer;
}

.listPagerButton i {
    font-size: 10px;
}

.listPagerButton:hover:not(:disabled) {
    background: #f3eefc;
}

.listPagerButton:disabled {
    color: #ccc;
    cursor: default;
}

.listPagerRange {
    padding: 0 4px;
    white-space: nowrap;
}
</style>
